<div class="relative" (click)="onClick.emit($event)">
  <p-iconField iconPosition="left">
    @if (!hideIcon) {
      @if (loading) {
        <p-inputIcon styleClass="pi pi-spinner pi-spin" />
      } @else {
        <p-inputIcon styleClass="pi pi-search" />
      }
    }
    <input
      class="w-full pr-8 !shadow-none"
      type="text"
      pInputText
      [class]="inputClass"
      [placeholder]="placeholder !== '' ? placeholder : (actionPrefix + 'search' | translate)"
      [disabled]="disabled"
      [(ngModel)]="keyword"
      (keydown)="onKeydown.emit($event)"
      (input)="onInput($event)" />
  </p-iconField>

  @if (keyword) {
    <div class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer" (click)="onClearKeyword()">
      <i class="icon-wl-close text-4"></i>
    </div>
  }
</div>
